import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";

import Login from "./components/Login/Login";
import Verify from "./components/Verify/Verify";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";
import AboutUs from "./components/About-us/AboutUs";
import Shop from "./components/Shop/Shop";
import Contact from "./components/Contact us/Contact";
import CustomiseWheat from "./components/Customise-wheat/CustomiseWheat";
import Cart from "./components/Cart/Cart";
import AccountSetting from "./components/User-profile/AccountSetting/AccountSetting";
import ProfileSidebar from "./components/User-profile/ProfileSidebar";
import MyOrder from "./components/User-profile/Order/MyOrder";
import UserPayment from "./components/User-profile/Payment/UserPayment";
import MyStuff from "./components/User-profile/MyStuff/MyStuff";
import Privacypolicy from "./components/Privacy-policy/Privacy-policy";
import "./assets/scss/style.scss";
import ComingSoon from "./components/Home/ComingSoon";
import Payment from "./components/Payment/Payment";
import OrderConfirmed from "./components/OrderConfirmation/OrderConfirmed";
import OrderTracking from "./components/User-profile/Tracking/OrderTracking";
import RefundPolicy from "./components/Refund-policy/Refund-policy";

function LocationGuard({ children }) {
    const location = useLocation();
    const [hasLocation, setHasLocation] = React.useState(
        () => !!localStorage.getItem("currentLocation") && !!localStorage.getItem("latitude")
    );

    React.useEffect(() => {
        const checkLocation = () => {
            const loc = localStorage.getItem("currentLocation");
            const lat = localStorage.getItem("latitude");
            const isSet = !!loc && !!lat;
            setHasLocation(isSet);

            if (!isSet) {
                window.dispatchEvent(new CustomEvent("openLocationModal"));
            }
        };

        checkLocation();

        window.addEventListener("locationFetched", checkLocation);
        return () => window.removeEventListener("locationFetched", checkLocation);
    }, [location.pathname]);

    if (!hasLocation) {
        return (
            <div className="container text-center py-5 my-5">
                <div className="card shadow border-0 p-5 mx-auto" style={{ maxWidth: "520px", borderRadius: "16px" }}>
                    <i className="fas fa-map-marker-alt display-4 mb-3" style={{ color: "#a37c4d" }}></i>
                    <h3 className="fw-bold mb-2 text-dark">Location Required</h3>
                    <p className="text-muted mb-4">
                        Please select or search your delivery location to view products and prices available in your area.
                    </p>
                    <button
                        className="btn py-3 fw-bold text-white shadow-sm w-100"
                        style={{ backgroundColor: "#a37c4d", borderRadius: "10px", fontSize: "16px" }}
                        onClick={() => window.dispatchEvent(new CustomEvent("openLocationModal"))}
                    >
                        📍 Select / Search Location Now
                    </button>
                </div>
            </div>
        );
    }

    return children;
}

function AppContent() {
    const location = useLocation();
    const profileRoutes = ["/my-order", "/account-setting", "/payment", "/my-stuff"];
    const isProfileRoute = profileRoutes.includes(location.pathname);

    return isProfileRoute ? (
        <div className="main-section">
            <Header />
            <div className="app-main-section">
                <div className="user-profile-page">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <ProfileSidebar />
                            </div>
                            <div className="col-lg-8">
                                <div className="pt_74 profile-content">
                                    <Routes>
                                        <Route path="/my-order" element={<MyOrder />} />
                                        <Route path="/account-setting" element={<AccountSetting />} />
                                        <Route path="/payment" element={<UserPayment />} />
                                        <Route path="/my-stuff" element={<MyStuff />} />
                                    </Routes>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    ) : (
        <div className="main-section">
            <Header />
            <div className="app-main-section">
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/verify" element={<Verify />} />
                    <Route path="/" element={<Home />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/shop" element={<LocationGuard><Shop /></LocationGuard>} />
                    <Route path="/contact-us" element={<Contact />} />
                    <Route path="/customize-wheat" element={<LocationGuard><CustomiseWheat /></LocationGuard>} />
                    <Route path="/cart" element={<LocationGuard><Cart /></LocationGuard>} />
                    <Route path="/privacy-policy" element={<Privacypolicy />} />
                    <Route path="/refund-policy" element={<RefundPolicy />} />
                    <Route path="/coming-soon" element={<ComingSoon />} />
                    <Route path="/order-payment" element={<LocationGuard><Payment /></LocationGuard>} />
                    <Route path="/order-confirmed" element={<OrderConfirmed />} />
                    <Route path="/order-tracking" element={<OrderTracking />} />
                </Routes>
            </div>
            <Footer />
        </div>
    );
}

function AppRoutes() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default AppRoutes;
